import { PlusOutlined } from "@ant-design/icons";
import { message } from "antd";
import { Input } from "antd";
import { Table, Tag, Popconfirm, Button, Modal, Select } from "antd";
import { useState, useEffect } from "react";
import { createAISystemPrompt, deleteAISystemPrompt, fetchAISystemPrompts, updateAISystemPrompt } from "../../api/ai";

const QuestionSystemPromptModalView = ({ open, categories, onClose }) => {
    const [systemPrompts, setSystemPrompts] = useState([])
    const tabCols = [
        {
            title: 'Index',
            dataIndex: 'index',
            key: 'index',
            render: (text, record, index) => {
                return (index + 1);
            }
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (text, record, index) => {
                if (record.isEditing) {
                    return <Select
                        style={{width: 240}}
                        options={categories}
                        value={record.categoryId ? record.categoryId : record.category?.id}
                        placeholder="select category..."
                        onChange={value => onInputChange('categoryId', value, index)}
                    />;
                }
                return <Tag>{record.category?.name}</Tag>;
            }
        },
        {
            title: 'System Prompt',
            dataIndex: 'description',
            key: 'description',
            render: (text, record, index) => {
                if (record.isEditing) {
                    return <Input.TextArea
                        style={{width: 300}}
                        value={record.description}
                        placeholder="prompt..."
                        onChange={evt => onInputChange('description', evt.target.value, index)}
                    />;
                }
                return <b>{text}</b>
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    record.isEditing ?
                        <Button.Group size='small'>
                            <Button type='link' loading={record.isLoading} onClick={() => saveEdit(record)}>Save</Button>
                            <Button type='link' onClick={() => cancelEdit(record)}><label style={{ color: '#afafaf', cursor: 'pointer' }}>Cancel</label></Button>
                        </Button.Group>
                        :
                        <Button.Group size='small'>
                            <Button type='link' onClick={() => editHandle(record)}>Edit</Button>
                            <Popconfirm
                                title="Delete"
                                description="Are you sure to delete this system prompt?"
                                onConfirm={() => deleteHandle(record)}
                                okText="Yes"
                                cancelText="No" >
                                <Button danger type='link' loading={record.isLoading}>Delete</Button>
                            </Popconfirm>
                        </Button.Group>
                )
            }
        }
    ];

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        fetchAISystemPrompts({'page.disable': true}).then(res => {
            if(res.list) {
                setSystemPrompts(res.list);
            }
        })
    }

    const editHandle = (item) => {
        item.isEditing = true;
        setSystemPrompts([...systemPrompts]);
    }

    const deleteHandle = (item) => {
        item.isLoading = true;
        setSystemPrompts([...systemPrompts]);
        deleteAISystemPrompt(item.id).then(res => {
            if(res) {
                fetchData();
            }
        })
    }

    const onInputChange = (key, value, index) => {
        systemPrompts[index][key] = value;
        setSystemPrompts([...systemPrompts]);
    }

    const saveEdit = (item) => {
        let canSubmit = String(item.description).trim();
        if (!canSubmit) {
            message.warning('Prompt can not be empty!'); return;
        }
        canSubmit = parseInt(item.categoryId) > 0 || parseInt(item.category?.id ?? '0') > 0 ;
        if (!canSubmit) {
            message.warning('Please select prompt category!'); return;
        }
        item.isLoading = true;
        setSystemPrompts([...systemPrompts]);

        if (item.id === '-1') {
            delete item.id;
            createAISystemPrompt({
                categoryId: item.categoryId,
                description: item.description
            }).then(res => {
                fetchData();
            })
        } else {
            updateAISystemPrompt({
                id: item.id,
                categoryId: item.categoryId ? item.categoryId : item.category?.id,
                description: item.description
            }).then(res => {
                fetchData();
            })
        }
    }

    const cancelEdit = (item) => {
        item.isEditing = false;
        let newData = [...systemPrompts].filter(cgr => cgr.id !== '-1');
        setSystemPrompts(newData);
    }

    const addNewSystemPrompt = () => {
        setSystemPrompts([
            {
                categoryId: null,
                systemPrompt: '',
                id: '-1',
                isEditing: true,
            }, ...systemPrompts
        ]);
    }

    return (
        <Modal
            title="System Prompt"
            maskClosable
            open={open}
            footer={null}
            width={900} onCancel={onClose} >
            <div style={{ width: '100%', maxHeight: '80vh', overflow: 'auto' }}>
                <div style={{ margin: '16px 0' }}>
                    <Button type='primary' icon={<PlusOutlined />} onClick={addNewSystemPrompt}>Create System Prompt</Button>
                </div>
                <Table rowKey={(record) => record.id} rowClassName={'table-row'} size='small' dataSource={systemPrompts} columns={tabCols} pagination={false} expandable={{ rowExpandable: (record) => false, showExpandColumn: false }} />
            </div>
        </Modal>

    )
}

export default QuestionSystemPromptModalView;